<template>
  <div>
    <div class="banner-home-config full-width-custom display-block-custom">
      <img src="../../images/landing/home/banner_landing.png" alt="">
      <div class="text-banner-position">
        <h1 class="title-banner">CHUSPIC</h1>
        <h3 class="sub-title-banner">
          {{$t("landing.home.sale")}}<br>
          {{$t("landing.home.photographs")}}
        </h3>
        <p class="text-banner">
          {{$t("landing.home.technology")}}<br>
          <strong>  {{$t("landing.home.number")}}</strong>
        </p>
      </div>
    </div>

    <div class="full-width-custom display-hidden-custom">
      <div class="padding-banner">
        <h3 class="text-color-primary title-banner-mobile">
          {{$t("landing.home.sale")}}<br>
          {{$t("landing.home.photographs")}}
        </h3>
        <p class="text-color-secondary text-banner-mobile">
          {{$t("landing.home.technology")}} <br>
          {{$t("landing.home.number")}}
        </p>
      </div>
      <img src="../../images/landing/home/banner_landing.png" alt="">

    </div>
    <section class="mt-50-custom">
      <div class="container ">
        <div class="row">
          <div class="col-lg-12 ">
            <h1 class="text-center title-about"> {{$t("landing.home.howDoes")}} <br> <strong class="strong-title">CHUSPIC</strong>? </h1>
            <iframe width="100%" height="513" src="https://www.youtube.com/embed/E1phulZ4rp4" title="CHUSPIC"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </section>
    <div class="box-blue mt-100-custom">
      <div class="wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 ">
              <div class="d-flex align-items-center-custom justify-content-custom mt-200-custom">
                <p class="text-color-secondary text-align-right-custom font-size-25">
                  {{$t("landing.home.platform")}}<br>
                  {{$t("landing.home.facialRecognition")}} <br>
                  {{$t("landing.home.numerical")}} <br>
                  {{$t("landing.home.automaticallyOrganize")}} <br>
                  {{$t("landing.home.eventPhotos")}}
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="container-video-recognition">
                <img class="img-position-video" src="../../images/landing/home/recognition.png" alt="">
                <a target="_blank" href="https://youtube.com/shorts/P7FtepfbEGI">
                  <img
                      class="img-button-play"
                      src="../../images/landing/home/button_play.png" alt="">
                </a>
              </div>

            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-8 ">
              <div class="container-image">
                <div class="image-row">
                  <img src="../../images/landing/home/categories/base.png" alt="Biometric Authentication"
                       class="responsive-image">
                  <img src="../../images/landing/home/categories/run.png" alt="Happy People" class="responsive-image">
                  <img src="../../images/landing/home/categories/drink.png" alt="American Football"
                       class="responsive-image">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="d-flex align-items-center-custom justify-content-custom mt-80-custom">
                <p class="text-color-secondary font-size-25">
                  {{$t("landing.home.organize")}}
                </p>
              </div>
            </div>
            <div class="col-md-4 ">
              <div class="d-flex align-items-center-custom justify-content-custom mt-140-custom padding-20-custom">
                <p class="text-color-secondary text-align-right-custom font-size-25">
                  {{$t("landing.home.eventSocial")}}
                </p>
              </div>
            </div>
            <div class="col-md-8 -mt-35">
              <img src="../../images/landing/home/categories/comercial_cart.png" alt="">
            </div>
            <div class="col-md-8 -mt-20">
              <img src="../../images/landing/home/categories/mobile.png" alt="">
            </div>
            <div class="col-md-4 ">
              <div class="d-flex align-items-center-custom justify-content-custom mt-140-custom padding-20-custom">
                <p class="font-size-25 color-gray-custom-text">
                  {{$t("landing.home.findPhotos")}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-gray mb-100-custom display-block-custom">
      <div class="wrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <h1 class="title-all text-align-center-custom">{{$t("landing.home.titleEasy")}}</h1>
              <h3 class="sub-title-about text-align-center-custom">{{$t("landing.home.register")}}</h3>
            </div>
          </div>
        </div>
        <div class="space-footer full-width-custom">
          <div class="d-flex justify-content-custom flex-1-custom">
            <div class="bg-secondary-color padding-100-cards width-1-3">
              <div class="d-flex justify-content-custom">
                <p class="text-card-ban">
                  {{$t("landing.home.upload")}} <br>
                  {{$t("landing.home.banners")}} <br>
                  {{$t("landing.home.categories")}}
                </p>
              </div>
            </div>
            <div class="bg-primary-color padding-100-cards width-1-3">
              <div class="d-flex justify-content-custom">
                <img src="../../images/landing/home/upload_pictures.png" class="width-200 height-150" alt="">
              </div>
              <h1 class="sub-text-card">{{$t("landing.home.goesUp")}}
                <br>
                {{$t("landing.home.photos")}}</h1>
            </div>
            <div class="bg-primary-color padding-100-cards width-1-3">
              <div class="d-flex justify-content-custom">
                <img src="../../images/landing/home/sale_pictures.png" alt="">
              </div>
              <h1 class="sub-text-card"> {{$t("landing.home.giveAway")}} </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="display-hidden-custom mt-80">
      <div class="wrapper">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <h1 class="title-all text-align-center-custom">{{$t("landing.home.titleEasy")}}</h1>
              <h3 class="sub-title-about text-align-center-custom">{{$t("landing.home.register")}}</h3>
            </div>
          </div>
        </div>
        <div class="space-footer full-width-custom">
          <div class="justify-content-custom flex-1-custom">
            <div class="bg-secondary-color padding-100-cards full-width-custom">
              <div class="d-flex justify-content-custom">
                <p class="text-card-ban">
                  {{$t("landing.home.upload")}} <br>
                  {{$t("landing.home.banners")}} <br>
                  {{$t("landing.home.categories")}}
                </p>
              </div>
            </div>
            <div class="bg-primary-color padding-100-cards full-width-custom">
              <div class="d-flex justify-content-custom">
                <img src="../../images/landing/home/upload_pictures.png" class="width-200 height-150" alt="">
              </div>
              <h1 class="sub-text-card">{{$t("landing.home.goesUp")}}
                <br>
                {{$t("landing.home.photos")}}</h1>
            </div>
            <div class="bg-primary-color padding-100-cards full-width-custom">
              <div class="d-flex justify-content-custom">
                <img src="../../images/landing/home/sale_pictures.png" alt="">
              </div>
              <h1 class="sub-text-card">  {{$t("landing.home.giveAway")}} </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="mt-50-custom ">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="title-all text-align-center-custom">{{$t("landing.home.stories")}}</h1>
            <h3 class="sub-title-about text-align-center-custom">{{$t("landing.home.happyCustomers")}}</h3>
          </div>
        </div>
      </div>
      <div class="display-block-custom">
        <div class="container-image">
          <div class="image-row">
            <img src="../../images/landing/home/biometric.png" alt="Biometric Authentication" class="responsive-image">
            <img src="../../images/landing/home/happy.png" alt="Happy People" class="responsive-image">
            <img src="../../images/landing/home/american.png" alt="American Football" class="responsive-image">
          </div>
        </div>
      </div>
      <div class="display-hidden-custom">
        <Carrousel :slides="items"/>
      </div>

    </section>
    <div class="box-gray-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 section-categories-margin">
            <h1 class="title-all text-align-center-custom">{{$t("landing.home.everyone")}}</h1>
            <h3 class="sub-title-about text-align-center-custom">{{$t("landing.home.findCategory")}}</h3>
          </div>
        </div>
      </div>
      <div class="image-row">
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/photo.png" alt="Fotografos">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.photographers")}}
            </h1>
          </div>
        </div>
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/events.png" alt="Eventos deportivos">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.eventsSports")}}
            </h1>
          </div>
        </div>
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/schools.png" alt="Escuelas">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.schools")}}
            </h1>
          </div>
        </div>
      </div>
      <div class="image-row space-footer">
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/conferences.png" alt="Conferencias">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.conventions")}}
            </h1>
          </div>
        </div>
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/concerts.png" alt="Conciertos">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.concerts")}}
            </h1>
          </div>
        </div>
        <div class="banner-home-config">
          <img src="../../images/landing/home/categories/expos.png" alt="Eventos Expos">
          <div class="text-center-img">
            <h1 class="text-white-custom text-shadow">
              {{$t("landing.home.expos")}}
            </h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Carrousel from "../../components/Carrousel.vue";

export default {
  name: "Landing",
  components: {Carrousel},
  data() {
    return {
      items: [
        require('../../images/landing/home/biometric.png'),
        require('../../images/landing/home/happy.png'),
        require('../../images/landing/home/american.png'),
      ],
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/landing/main';

img {
  width: 100%
}

.container-video-recognition {
  position: relative;
  display: inline-block
}

.container-video-recognition .img-position-video {
  display: block;
  width: 100%
}

.img-button-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px
}


.container-image {
  padding: 10px;
}

.image-row {
  width: 100%;
  display: flex;
  justify-content: center;
}

.responsive-image {
  width: 33.333%;
  object-fit: cover;
  height: auto;
}

@media (max-width: 768px) {
  .custom-container {
    padding-left: 0;
    padding-right: 0;
  }
  .custom-col {
    padding-left: 0;
    padding-right: 0;
  }
  .responsive-image {
    width: 100%;
  }

  .image-row {
    width: 100%;
    display: block;
  }
  .box-gray-footer {
    clip-path: none !important;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;
    background-color: #ededed;
  }
  .section-categories-margin {
    margin-top: 0px !important;
    padding: 30px !important;
  }
  .box-gray {
    background-color: #ededed;
    padding: 0px !important; /* Added a percentage value for top/bottom padding to keep the wrapper inside of the parent */

    -webkit-transform: skewY(-5deg);
    -moz-transform: skewY(-5deg);
    -ms-transform: skewY(-5deg);
    -o-transform: skewY(-5deg);
    transform: skewY(-5deg);
  }
}

.box-gray-footer {
  clip-path: polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%);
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: #ededed;
}

.box-blue {
  background-color: $landing-primary-color;
  padding: 5% 20px;

  -webkit-transform: skewY(-5deg);
  -moz-transform: skewY(-5deg);
  -ms-transform: skewY(-5deg);
  -o-transform: skewY(-5deg);
  transform: skewY(-5deg);
}

.box-blue > .wrapper {
  -webkit-transform: skewY(5deg);
  -moz-transform: skewY(5deg);
  -ms-transform: skewY(5deg);
  -o-transform: skewY(5deg);
  transform: skewY(5deg);
}

.box-gray > .wrapper {
  -webkit-transform: skewY(5deg);
  -moz-transform: skewY(5deg);
  -ms-transform: skewY(5deg);
  -o-transform: skewY(5deg);
  transform: skewY(5deg);
}

.box-gray {
  z-index: 0 !important;
  background-color: #ededed;
  padding: 5% 20px; /* Added a percentage value for top/bottom padding to keep the wrapper inside of the parent */

  -webkit-transform: skewY(-5deg);
  -moz-transform: skewY(-5deg);
  -ms-transform: skewY(-5deg);
  -o-transform: skewY(-5deg);
  transform: skewY(-5deg);
}


.mt-video-home {
  margin-top: 60px;
}

.title-about {
  font-family: Arial, serif !important;
  font-size: 40px !important;
  color: $landing-secondary-color !important;
}

.sub-title-about {
  font-family: Helvetica, O, serif !important;
  font-size: 30px !important;
  color: $landing-secondary-color !important;
}

.title-all {
  font-family: Arial, serif !important;
  font-size: 40px !important;
  color: $landing-primary-color !important;
}

.strong-title {
  color: $landing-primary-color !important;
  font-family: $font-bold !important;
}


.text-banner-position {
  top: 52% !important;
  left: 31% !important;
  color: white !important;
  font-family: Arial, serif !important;
  transform: translate(-50%, -50%) !important;
  position: absolute !important;
}

.title-banner {
  font-size: 70px !important;
  font-weight: bold !important
}

.sub-title-banner {
  font-size: 40px !important;
}

.text-banner {
  font-size: 30px !important;
}

.padding-banner {
  padding: 30px 60px 30px 60px !important;
}

.title-banner-mobile {
  font-size: 27px
}

.text-banner-mobile {
  font-size: 18px;
  font-weight: bold;
}
</style>
